import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'

function renderDialogText(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__confirm`
    },
    [ this.getTranslate(`${Services.sendings}.confirm.send.text`) ]
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.cancel'),
            mode: buttonModes.flat,
            disabled: this.loading
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.continue'),
            loading: this.loading,
            disabled: this.loading,
            color: Colors.primary
          },
          on: {
            click: () => {
              this.send()
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.title,
        value: this.showDialog,
        maxWidth: 600
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogText.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    button,
    {
      props: this.buttonProps,
      on: {
        click: () => {
          this.showDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
